import { CoinID } from '@starsoft/common/enums';

export const blockedSportsCoins = [CoinID.TON, CoinID.AXS, CoinID.POL];
